import { Injectable } from '@angular/core';
import { AppConstants } from '../../../constants/app.constants';
import { environment } from '../../../../environments/environment.prod';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CompanyPlanModel } from '../../../models/company.model';

@Injectable()
export class MySubscriptionService {
  baseUrl: string = AppConstants.accessBaseUrl;
  API_KEY = environment.secreteKey;
  private readonly headers = new HttpHeaders({ 'x-api-key': this.API_KEY, 'Content-Type': 'application/json' });
  options = { headers: this.headers };

  constructor(private readonly http: HttpClient) { }

  getCompanyPlans() {
    return this.http.get<CompanyPlanModel[]>(this.baseUrl + 'Company/' + AppConstants.getCompanyPlans, this.options);
  }
  
  getActivePlanUid() {
    return this.http.get<string>(this.baseUrl + 'Company/' + AppConstants.getActivePlanUid, this.options);
  }

}
